import useEvent from '@lyearn/core/hooks/useEvent';
import ENPSRating from '@/modules/user-survey/components/ENPSRating';
import useQuestionPlayerResponse from '@/modules/user-survey/hooks/useQuestionPlayerResponse';
import QuestionPlayerContainer from '@/modules/user-survey/questions/components/QuestionPlayerContainer';
import { QuestionPlayerProps } from '@/modules/user-survey/questions/types';
import { ResourceResponseTypeEnum } from '@/types/schema';

const ENPSQuestionPlayer = (props: QuestionPlayerProps) => {
  const {
    variant,
    question,
    userSurveyQuestionSettings,
    error,
    response,
    onChange,
    useRichTextForComment,
    commentTitle,
    disabled,
    requireComments,
  } = props;
  const actions = useQuestionPlayerResponse({ response, onChange });

  const onValueChange = useEvent((enpsResponse: number) => {
    if (disabled) {
      return;
    }

    actions.onQuestionResponseChange({
      responseType: ResourceResponseTypeEnum.Enps,
      enpsResponse,
    });
  });

  return (
    <QuestionPlayerContainer
      commentTitle={commentTitle}
      disabled={disabled}
      error={error}
      post={response?.post}
      question={question}
      requireComments={requireComments}
      useRichTextForComment={useRichTextForComment}
      userSurveyQuestionSettings={userSurveyQuestionSettings}
      variant={variant}
      onPostChange={actions.onPostChange}>
      <ENPSRating
        className={variant === 'form' ? 'mt-16 py-4' : 'mt-32 py-16'}
        size={variant === 'form' ? 'medium' : 'large'}
        value={response?.questionSurveyResponse?.enpsResponse}
        onChange={onValueChange}
      />
    </QuestionPlayerContainer>
  );
};

export default ENPSQuestionPlayer;
